import { deserialize, deserializeAs } from 'cerialize';
import { RAccountDetails } from './account-details.record';
import { ROrganization } from './organization-record';

export class RAccountInformationDetails {
    @deserialize
    hasOrg: boolean = false;
    @deserializeAs(RAccountDetails)
    accounts: Array<RAccountDetails> = [];
    @deserializeAs(ROrganization)
    organizations: Array<ROrganization> = []
}
